import { devApiUrl, prodApiUrl } from './api-url';
import { devCollectionId, prodCollectionId } from './collection-id';
import { devCommonUrl, prodCommonUrl } from './common-url';
import { devAppDeepLink, prodAppDeepLink } from './deep-link';
import {
  devDistributorClientUid,
  prodDistributorClientUid,
} from './distributor-client-uid';
import {
  devIntroMochipayUrl,
  prodIntroMochipayUrl,
} from './intro-mochipay-url';

const ENV =
  process.env['NEXT_PUBLIC_APP_ENV'] ||
  process.env['NODE_ENV'] ||
  'development';
// const ENV = 'production';

const domainData: any = {
  development: {
    ...devCommonUrl,
    DISTRIBUTOR_MOCHIPAY_URL: devIntroMochipayUrl,
    API_URL: devApiUrl,
    APP_DEEP_LINK: devAppDeepLink,
    DISTRIBUTOR_CLIENT_UID: devDistributorClientUid,
    COLLECTION_ID: devCollectionId,
  },

  production: {
    ...prodCommonUrl,
    DISTRIBUTOR_MOCHIPAY_URL: prodIntroMochipayUrl,
    API_URL: prodApiUrl,
    APP_DEEP_LINK: prodAppDeepLink,
    DISTRIBUTOR_CLIENT_UID: prodDistributorClientUid,
    COLLECTION_ID: prodCollectionId,
  },
};

const DOMAIN = domainData[ENV];

export { DOMAIN, ENV };
